import { createAsyncThunk } from "@reduxjs/toolkit";
import { ApiPermissoes } from "service/api/permissao/ApiPermissoes";
import { ErrosUtils } from "util/ErrosUtils";


export class AutorizacaoAction {
  static readonly iniciar = createAsyncThunk(
    'Autorizacao/papeis/iniciar',
    async (it, {rejectWithValue}) => {
      try {
        return await ApiPermissoes.papeis();
      } catch (e) {
        return rejectWithValue(ErrosUtils.converterErroAxiosParaErroSistema(e));
      }
    }
  )
}
